import { FlexibleDate, FlexibleDateFormat, kv, Logger } from '@app/booking-libs';
import { JsmInvocation } from '@app/booking-types/types';
import { invoke, view } from '@forge/bridge';
import { Box, ErrorMessage, SectionMessage, Spinner, Text, useProductContext, xcss } from '@forge/react';
import React, { useEffect, useState } from 'react';
import { useBookingForm } from '../forms/BookingForm-reducer';
import { isStateValid } from '../forms/shared';
import { BookingForm } from '../forms/BookingForm';
import { JsmResourceSelection } from '../forms/components/JsmResourceSelection';
import { useUserContext } from '../libs/useUserContext';
import { useBookingFormFields } from '../libs/useBookingFormFields';
import { validateConfiguration } from './helpers';
const log = new Logger('JsmCreationPanel');
export default function JsmCreationPanel() {
    const [isLoading, setIsLoading] = useState(true);
    const [config, setConfig] = useState();
    const [error, setError] = useState('');
    const productContext = useProductContext();
    const { state, dispatch } = useBookingForm({});
    const { timezone } = useUserContext();
    useEffect(() => {
        async function load() {
            if (productContext) {
                const payload = {
                    portalId: productContext.extension.portal.id,
                    requestTypeId: productContext.extension.request.typeId
                };
                const result = await invoke(JsmInvocation.getConfiguration, payload);
                if (!result.success) {
                    if (result.message) {
                        setError(result.message);
                    }
                }
                else {
                    log.debug('Got a response from invocation', result.payload);
                    if (validateConfiguration(result.payload.config)) {
                        setConfig(result.payload.config);
                    }
                    else {
                        log.error('Configuration is broken');
                        setError('Configuration is not valid, check Booking Flow.');
                    }
                }
                setIsLoading(false);
            }
        }
        load();
    }, [productContext]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: we don't care about the timezone changing after the user has selected stuff
    useEffect(() => {
        if (config) {
            const keys = ['startDate', 'endDate', 'resource', 'summary'];
            const fields = keys.map((key) => {
                if (['startDate', 'endDate'].includes(key)) {
                    return { key, value: new FlexibleDate(state[key], timezone).toLocalString(FlexibleDateFormat.iso) };
                }
                return { key, value: state[key] };
            });
            const isValid = isStateValid(state, false);
            log.debug(`Updating the form values and validity ${kv('isValid', isValid)}`, fields);
            view.submit({ fields, isValid });
        }
    }, [state, config]);
    const { fields, loadingFields } = useBookingFormFields(config);
    if (isLoading || !productContext || (config && loadingFields)) {
        log.debug('Loading...');
        return React.createElement(Spinner, { size: 'large' });
    }
    if (error) {
        return React.createElement(ErrorMessage, null, error);
    }
    if (!config) {
        log.debug('No configuration found..., disabling panel');
        return null;
    }
    return (React.createElement(React.Fragment, null,
        error && React.createElement(SectionMessage, null, error),
        ' ',
        React.createElement(BookingForm, { fields: fields, state: state, hideSummary: true, dispatch: dispatch, renderResource: () => (React.createElement(Box, { xcss: xcss({ minHeight: '150px' }) },
                React.createElement(JsmResourceSelection, { configuration: config, state: state, onSelect: (resource) => dispatch({
                        type: 'update-resource',
                        payload: {
                            resource
                        }
                    }) }))) }),
        React.createElement(Text, null,
            "Timezone: ",
            productContext.timezone)));
}
